// extracted by mini-css-extract-plugin
export default {"container":"multi-cell_container__EgCp2","cell":"multi-cell_cell__j1L9A"};